import { useEffect } from 'react'
import {
  OG_IMAGE_URL,
  SITE_URL,
  upsertLink,
  upsertMeta,
  upsertJsonLd,
  removeJsonLd,
  breadcrumbJsonLd,
} from '../../seo/useSeo'
import { PARTNERS } from '../../content/partners'
import { MarketingHeader } from './MarketingHeader'
import { MarketingFooter } from './MarketingFooter'
import { useMarketingHeaderActions } from './useMarketingHeaderActions'

const TITLE = 'Unsere Partner – Kooperationen rund um Roofora'
const DESCRIPTION =
  'Ausgewählte Partner und Kooperationen rund um Roofora - kuratierte Empfehlungen, keine Linkliste.'
const BREADCRUMB_ID = 'partner-breadcrumb'

/** Small, deliberately curated backlink-exchange page - German-only like the blog (see
 *  content/blog/types.ts), reachable via the footer. Kept short on purpose: Google's guidelines
 *  flag "excessive link exchanges" as a link scheme, so this stays a handful of genuine mutual
 *  recommendations rather than growing into a link directory - see content/partners.ts. */
export function PartnerPage() {
  const headerActions = useMarketingHeaderActions()

  useEffect(() => {
    document.documentElement.lang = 'de'
    const canonicalUrl = `${SITE_URL}/partner`
    document.title = TITLE
    upsertMeta('name', 'description', DESCRIPTION)
    upsertMeta('property', 'og:type', 'website')
    upsertMeta('property', 'og:title', TITLE)
    upsertMeta('property', 'og:description', DESCRIPTION)
    upsertMeta('property', 'og:url', canonicalUrl)
    upsertMeta('property', 'og:image', OG_IMAGE_URL)
    upsertMeta('name', 'twitter:title', TITLE)
    upsertMeta('name', 'twitter:description', DESCRIPTION)
    upsertMeta('name', 'twitter:image', OG_IMAGE_URL)
    upsertLink('canonical', canonicalUrl)

    upsertJsonLd(
      BREADCRUMB_ID,
      breadcrumbJsonLd([
        { name: 'Roofora', url: `${SITE_URL}/de` },
        { name: 'Partner', url: canonicalUrl },
      ]),
    )

    return () => removeJsonLd(BREADCRUMB_ID)
  }, [])

  return (
    <>
      <MarketingHeader {...headerActions} />
      <div className="blog-page">
        <h1>Partner</h1>
        <p className="blog-list-intro">{DESCRIPTION}</p>
        <ul className="blog-list">
          {PARTNERS.map((partner) => (
            <li key={partner.url} className="blog-list-item">
              <a
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                className={partner.logo ? 'partner-link-with-logo' : undefined}
              >
                {partner.logo && (
                  <img className="partner-logo" src={partner.logo} alt="" width={48} height={48} loading="lazy" />
                )}
                <h2>{partner.name}</h2>
              </a>
              <p>{partner.description}</p>
            </li>
          ))}
        </ul>
      </div>
      <MarketingFooter />
    </>
  )
}
